import React from 'react'
import useUrlId from '../../hooks/use-url-id'
import { useWorkerQuery } from '../../queries/users'
import { getUserLabel } from '../../utils/users'
import { Element } from 'react-bulma-components'
import useQrCode from '../../hooks/use-qr-code'
import { useIsInternalWorker } from '../../hooks/use-is-internal-worker'
import { OrganizationTypeEnum } from '../../api/organizations'
import useStore from '../../store'

const QrPrintPage: React.FC = () => {
  const currentOrganization = useStore(state => state.session.currentOrganization)
  const { id } = useUrlId({ idName: 'userId' })
  const { data: user } = useWorkerQuery(id as string)
  const { isInternalWorker } = useIsInternalWorker(user)
  // A worker is external if the organization is an employer AND the worker is not internal
  const isExternalWorker =
    currentOrganization?.type === OrganizationTypeEnum.employer && !isInternalWorker
  const qrCode = useQrCode(id as string, isExternalWorker, !user)

  return (
    <>
      {qrCode && user && (
        <Element className="is-flex is-flex-direction-column is-align-items-flex-start" p={5}>
          <img
            data-test="user-qr-code"
            src={`data:image/png;base64, ${qrCode}`}
            style={{ maxWidth: 200, maxHeight: 200 }}
            onLoad={() => window.print()}
          />
          <Element style={{ fontSize: 18 }} pl={2}>
            {getUserLabel(user, { hideOfflineInfo: true })}
          </Element>
        </Element>
      )}
    </>
  )
}

export default QrPrintPage
